import HttpFactory from '../factory'
import type { Incident } from '../types/incident'

class IncidentsModule extends HttpFactory<any[]> {
  private RESOURCE = '/incidents'

  private RESOURCE_ALERT = '/alerts'

  async get(incidentId: String): Promise<Incident> {
    const result = await this.call<any>('GET', `${this.RESOURCE}/${incidentId}`)
    return result
  }

  /**
   * Fetch all open incidents for a specific patient
   * GET /incidents?patientId=:patientId&open=true
   * @param patientId
   */
  async getOpenByPatient(patientId: string): Promise<Incident[]> {
    return this.call<any>('GET', `${this.RESOURCE}?patientId=${patientId}&open=true`).then((response) => response.items)
  }

  async updateReminder(id: String, date: string): Promise<Incident> {
    const result = await this.call<any>('PUT', `${this.RESOURCE_ALERT}/${id}/reminder`, {
      remindAt: date,
    })
    return result
  }

  async getIncidentAlerts(id: String): Promise<Incident> {
    const result = await this.call<any>('GET', `${this.RESOURCE}/${id}${this.RESOURCE_ALERT}`)
    return result
  }

  async save(data: Partial<Incident>): Promise<Incident> {
    if (data.id) {
      return this.call<any>('PATCH', `${this.RESOURCE}/${data.id}?revision=${data.revision}`, {
        severity: data.severity,
        managerId: data.managerId,
        report: data.report,
        name: data.name,
      })
    } else {
      return this.call<any>('POST', `${this.RESOURCE}`, data)
    }
  }

  async closeAnomalie(data: Partial<Incident>): Promise<Incident> {
    return this.call<any>('PATCH', `${this.RESOURCE}/${data.id}?revision=${data.revision}`, {
      status: 'closed',
      classification: data.classification,
      report: data.report,
      managerId: data.managerId,
      severity: data.severity,
    })
  }

  async closeIncident(data: Partial<Incident>): Promise<Incident> {
    return this.call<any>('PATCH', `${this.RESOURCE}/${data.id}?revision=${data.revision}`, {
      status: 'closed',
      report: data.report,
      severity: data.severity,
    })
  }
}

export default IncidentsModule
